/* eslint-disable no-undef */
/**
 * Utilidades para la construcción de estado de modales.
 */

/**
 * Construye el título del modal según el estado del componente.
 * @param {boolean} sinCitas - Si el usuario ya tiene citas asignadas.
 * @param {boolean} hasAccess - Si el usuario tiene acceso al módulo.
 * @returns {string}
 */
export const buildModalTitle = (sinCitas, hasAccess) => {
  if (sinCitas) return 'Información cita médica';
  if (hasAccess === false) return 'Usuario No Válido';
  return '';
};

/**
 * Retorna el texto del botón principal del modal según el estado activo.
 * @param {boolean} error - Si hay un error activo.
 * @param {boolean} sincita - Si hay una cita existente.
 * @returns {string}
 */
export const getModalButtonText = (error, sincita) => {
  if (error || sincita) return parseText('sharedResources.Modal.Buttons.Cerrar');
  return parseText('sharedResources.Modal.Buttons.Cancelar');
};
